var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgStage = function SvgStage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-stage",
    viewBox: "0 0 640 480",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 480,
    fill: "#1a1a1a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60,
    width: 640,
    height: 40,
    fill: "#ff8c00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 140,
    width: 640,
    height: 40,
    fill: "#ff8c00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 220,
    width: 640,
    height: 40,
    fill: "#ff8c00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 300,
    width: 640,
    height: 40,
    fill: "#ff8c00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 380,
    width: 640,
    height: 40,
    fill: "#ff8c00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 240)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -4,
    width: 160,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -75,
    cy: 0,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 0,
    r: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -4,
    width: 160,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -75,
    cy: 0,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 0,
    r: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-25,-35 C-35,-35 -40,-25 -40,-15 C-40,5 -35,15 -25,20 L-15,25 L15,25 C25,20 30,10 30,5 C40,-5 40,-15 40,-25 C40,-35 35,-40 25,-35 L-25,-35 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -12,
    cy: -10,
    r: 6,
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: -10,
    r: 6,
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-5 L-4,5 L0,10 L4,5 Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: 12,
    width: 4,
    height: 8,
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: 12,
    width: 4,
    height: 10,
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12,
    width: 4,
    height: 8,
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 4,
    height: 10,
    fill: "#1a1a1a"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 450,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#ff8c00"
  }, "STAGING")));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStage);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;